import "./Home.module.css";
import Cabecera from "@/reusable_sections/Header";
import NuestraHistoria from "./sections/NuestraHistoria";
import NuestroAceite from "./sections/NuestroAceite";
import DelOlivarALaBotella from "./sections/DelOlivarALaBotella";
import CatasEnLaHaya from "./sections/CatasEnLaHaya";
import ParaTiendas from "./sections/ParaTiendas";
import Contacto from "./sections/Contacto";
import PieDePagena from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Cabecera />
      <NuestraHistoria />
      <NuestroAceite />
      <DelOlivarALaBotella />
      <CatasEnLaHaya />
      <ParaTiendas />
      <Contacto />
      <PieDePagena />
    </div>;
}